export { FreeResourceCard, type FreeResourceProps } from './FreeResourceCard'
